import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const MercedesFinancePage = () => {
  return (
    <LenderPageTemplate
      lenderName="Mercedes"
      slug="/lenders/mis-sold-mercedes-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default MercedesFinancePage
